module.exports = __webpack_public_path__ + "media/PAG60-01.9cf6dfc3.mp3";